import {bookingFilterService} from "../services/bookingFilterService";

const state = {
  currentFilter: {},
  savedFilters: [],
};

const getters = {
  currentFilter: (state)  => state.currentFilter,
  savedFilters: (state)  => state.savedFilters,
};

const mutations = {
  setCurrentFilter(state, filter) {
    state.currentFilter = filter;
  },
  setSavedFilters(state, filters) {
    state.savedFilters = filters;
  },
};

const actions = {
  setCurrentFilter({commit}, filter) {
    commit('setCurrentFilter', filter);
  },
  async loadSavedFilters({commit, state}, businessId) {
    const result = await bookingFilterService.get(businessId);
    // if (error) {
    //   console.error('error', error);
    //   return
    // }
    commit('setSavedFilters', result.data);
  },
};


export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
